import React from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import Claims from "./Claims";

const ClaimComp: React.FC = () => {
  return (
    <div className="orders">
      <Sidebar activeTab="Claims" />
      <Claims />
    </div>
  );
};

export default ClaimComp;
